import { createFlyerDetailPageFormPositionState } from "../types/flyer-detail-page-form-position-state/flyer-detail-page-form-position-state.functions";
import { FlyerDetailPageFormPositionState } from "../types/flyer-detail-page-form-position-state/flyer-detail-page-form-position-state.interface";

import { flyerDetailPageFormPositionCategoriesReducer } from "./flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.reducer";
import { FlyerDetailPageFormPositionCategoriesActionType } from "./flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.actions";
import {
  FlyerDetailPageFormPositionActions,
  FlyerDetailPageFormPositionActionType,
} from "./flyer-detail-page-form-position.actions";

export function flyerDetailPageFormPositionReducer(
  state = createFlyerDetailPageFormPositionState(),
  action: FlyerDetailPageFormPositionActionType
): FlyerDetailPageFormPositionState {
  switch (action.type) {
    case FlyerDetailPageFormPositionActions.FetchPosition:
      return {
        ...state,
        isLoading: true,
      };
    case FlyerDetailPageFormPositionActions.FetchPositionSuccess:
    case FlyerDetailPageFormPositionActions.SavePositionSuccess:
      return {
        ...state,
        isLoading: false,
        position: action.payload,
      };
    case FlyerDetailPageFormPositionActions.FetchPositionFailure:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FlyerDetailPageFormPositionActions.SavePosition:
      return {
        ...state,
        isLoading: true,
      };
    case FlyerDetailPageFormPositionActions.Reset:
      return createFlyerDetailPageFormPositionState();
    default:
      return {
        ...state,
        categoryState: flyerDetailPageFormPositionCategoriesReducer(
          state.categoryState,
          action as FlyerDetailPageFormPositionCategoriesActionType
        ),
      };
  }
}
